import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import sideMenuItems from './Menu';
import { permission as usePermission } from 'store/auth/selector';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { pushPage, pushPageSize, updateFilters } from 'store/state/stateSlice';
import 'styles/scrollbar.css';
import { ChevronDown } from 'lucide-react';

export const SideBar: React.FC = () => {
  const permission = useSelector(usePermission);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(true);

  const hasPermission = (policy: string | undefined) => {
    return policy
      ? (permission || []).some((item: any) => item?.description === policy)
      : true;
  };

  const handlePageSizeChange = () => {
    dispatch(pushPage(1 as any));
    dispatch(pushPageSize(10 as any));
    dispatch(updateFilters({}));
  };

  return (
    <div className='fixed'>
      <div
        className={` ${
          open ? 'w-60  ' : ' w-30 '
        }   bg-gray-50 h-screen overflow-y-scroll md:pb-28 p-5 relative duration-300 md:block hidden`}
      >
        <div className='text-[13px] font-poppinsMedium'>
          {sideMenuItems.map(
            (item, key) =>
              hasPermission(item.policy) && (
                <div key={key}>
                  {item.subMenu?.length ? (
                    <details className='group space-y-1'>
                      <summary
                        className={`px-3 py-3 flex items-center gap-4 rounded-lg hover:text-theme700 ${
                          location.pathname === item.to && 'text-theme700'
                        } cursor-pointer`}
                      >
                        {React.createElement(item.icon, {
                          className: 'text-md h-5 w-5',
                        })}
                        <span>{item.name}</span>

                        <ChevronDown className='ml-auto transition duration-300 group-open:-rotate-180 h-5 w-5' />
                      </summary>
                      <div className='pl-6'>
                        {item.subMenu.map(
                          (subItem, subKey) => (
                            // hasPermission(subItem.policy) && (
                            <div
                              key={subKey}
                              className={`flex items-center gap-4 px-3 py-2 relative cursor-pointer ${
                                location.pathname === subItem.to
                                  ? 'h-11 text-theme700 rounded-r-lg'
                                  : 'h-11 hover:text-theme700'
                              }`}
                              onClick={() => {
                                if (subItem.to) {
                                  navigate(subItem.to);
                                  handlePageSizeChange();
                                }
                              }}
                            >
                              {subItem.icon &&
                                React.createElement(subItem.icon, {
                                  className: 'text-[12px] h-5 w-5',
                                })}
                              <span>{subItem.title}</span>
                            </div>
                          )
                          // )
                        )}
                      </div>
                    </details>
                  ) : (
                    <div
                      className={`px-3 py-3 flex items-center gap-4 relative ${
                        !item.to
                          ? 'cursor-not-allowed text-gray-800'
                          : 'cursor-pointer hover:text-theme700'
                      } ${
                        location.pathname === item.to
                          ? 'h-12 text-theme700 rounded-r-lg'
                          : 'h-12'
                      }`}
                      onClick={() => [
                        item.to && navigate(item.to),
                        handlePageSizeChange(),
                      ]}
                    >
                      {React.createElement(item.icon, {
                        className: 'text-[11px] h-5 w-5',
                      })}
                      <span>{item.name}</span>
                    </div>
                  )}
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};
